import { render } from "./LoadingOverlay.vue?vue&type=template&id=ac1597b4&scoped=true"
const script = {}

import "./LoadingOverlay.vue?vue&type=style&index=0&id=ac1597b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac1597b4"]])

export default __exports__